import { Injectable } from '@angular/core';
import _ from 'lodash';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class PythonVisualizationModel extends ModeModelBase {
  override _name = 'pythonVisualization';
  override idAttribute = 'token';
  override belongsTo = 'report';
  override parentIdAttribute = 'token';
  override hasOne = [
    { name: 'pythonCell', idAttribute: 'token' },
    { name: 'pythonCellRun', idAttribute: 'token' },
  ];
  override attributes = [
    { name: 'view', default: null, type: 'text' },
    { name: 'created_at', default: '' },
    { name: 'title', default: '' },
    { name: 'frozen_in_layout', default: false },
  ];
  pythonCellToken: any;
  vizLink: any;
  title: string;
  state: string;
  savedResults: any;
  override initialize(resource) {
    if (resource && resource.hasLink('python_cell')) {
      this.pythonCellToken = resource.links('python_cell').href.split('/cells/')[1];
    }
    if (resource && resource.hasLink('report_pythonviz_web')) {
      this.vizLink = resource.links('report_pythonviz_web').href;
    }
  }
  override toParams() {
    return { 'report_layout_python_cell.title': this.title || '' };
  }
  getVizReportRunLink(reportRunToken) {
    return this._resource.hasLink('report_run_pythonviz_web')
      ? this._resource.links('report_run_pythonviz_web').$expand({ token: reportRunToken }, { excludeSSLPort: true })
      : '';
  }
  renderEmbed(reportRunToken) {
    return {
      title: this.title,
      state: this.state === 'empty' ? 'empty' : 'succeeded',
      vizLink: this.vizLink,
      vizReportRunLink: this.getVizReportRunLink(reportRunToken),
      results: _.map(this.savedResults, (result) => {
        return {
          content: result.content,
          type: result.content_type,
          result_type: result.result_type,
        };
      }),
    };
  }
}

@Injectable({ providedIn: 'root' })
export class PythonVisualizationModelAccessor extends ModelAccessorBase<PythonVisualizationModel> {
  override name = 'pythonVisualization';
  override idAttribute = 'token';
  override parentModel = 'report';
  override parentIdAttribute = 'token';
  override createAttributes = ['report'];
  createModel(resource, opts?) {
    const model = new PythonVisualizationModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.pythonVisualization');
  }
}
